import { useTranslation } from 'react-i18next';

import type { PlatformId } from './types';

// Mini-chips "maison" : lettrage court + couleur distinctive par plateforme.
// On ne réutilise JAMAIS les logos propriétaires — uniquement un marquage neutre.

export interface PlatformMeta {
  id: PlatformId;
  /** Nom complet, pour tooltip / accessibilité. */
  label: string;
  /** Lettrage court affiché dans la pastille. */
  short: string;
  /** Couleur distinctive (hex). */
  color: string;
}

export const PLATFORM_REGISTRY: Record<PlatformId, PlatformMeta> = {
  MT4: { id: 'MT4', label: 'MetaTrader 4', short: 'MT4', color: '#E68A00' },
  MT5: { id: 'MT5', label: 'MetaTrader 5', short: 'MT5', color: '#0EA5A4' },
  cTrader: { id: 'cTrader', label: 'cTrader', short: 'cT', color: '#7C3AED' },
  TradingView: { id: 'TradingView', label: 'TradingView', short: 'TV', color: '#2962FF' },
  DXtrade: { id: 'DXtrade', label: 'DXtrade', short: 'DX', color: '#0891B2' },
  'Match-Trader': { id: 'Match-Trader', label: 'Match-Trader', short: 'M-T', color: '#B45309' },
  TradeLocker: { id: 'TradeLocker', label: 'TradeLocker', short: 'TL', color: '#4F46E5' },
  NinjaTrader: { id: 'NinjaTrader', label: 'NinjaTrader', short: 'NT', color: '#16A34A' },
  Tradovate: { id: 'Tradovate', label: 'Tradovate', short: 'TDV', color: '#0284C7' },
  Rithmic: { id: 'Rithmic', label: 'Rithmic', short: 'RI', color: '#DB2777' },
  autre: { id: 'autre', label: 'Autre plateforme', short: 'AUT', color: '#64748B' },
};

export interface PlatformChipProps {
  platform: PlatformId;
  className?: string;
}

/** Pastille arrondie originale (lettrage + couleur), sans logo propriétaire. */
export function PlatformChip({ platform, className }: PlatformChipProps): React.JSX.Element {
  const { t } = useTranslation('propfirms');
  const meta = PLATFORM_REGISTRY[platform];
  const other = platform === 'autre';
  return (
    <span
      title={other ? t('platform.other') : meta.label}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold leading-none text-white md:text-[10px]${
        className ? ` ${className}` : ''
      }`}
      style={{ backgroundColor: meta.color }}
    >
      {other ? t('platform.otherShort') : meta.short}
    </span>
  );
}
